const meta = { requiresAuth: true };
const metaAdmin = { requiresAuth: true, requiresAdmin: true };

const Settings = () => import(/* webpackChunkName: "settings" */ '@/views/settings/Root');
const SettingsGuard = () => import(/* webpackChunkName: "settings-guard" */ '@/views/settings/Guard');
const SettingsTemplate = () => import(/* webpackChunkName: "settings-template" */ '@/views/settings/template/Root');
const SettingsTemplateIndex = () => import(/* webpackChunkName: "settings-template-index" */ '@/views/settings/template/Index');
const SettingsPayroll = () => import(/* webpackChunkName: "settings-payroll" */ '@/views/settings/payroll-group/Root');
const SettingsPayrollIndex = () => import(/* webpackChunkName: "settings-payroll-index" */ '@/views/settings/payroll-group/Index');
const SettingsPayrollForm = () => import(/* webpackChunkName: "settings-payroll-form" */ '@/views/settings/payroll-group/Form');
const SettingsManageUser = () => import(/* webpackChunkName: "settings-manage-user" */ '@/views/settings/manage-user/Root');
const SettingsManageUserRoles = () => import(/* webpackChunkName: "settings-manage-user-roles" */ '@/views/settings/manage-user/roles/Root');
const SettingsManageUserRolesForm = () => import(/* webpackChunkName: "settings-manage-user-roles-form" */ '@/views/settings/manage-user/roles/Form');
const SettingsManageUserRolesIndex = () =>
  import(/* webpackChunkName: "settings-manage-user-roles-index" */ '@/views/settings/manage-user/roles/Index');
const SettingsManageUserAssignRole = () =>
  import(/* webpackChunkName: "settings-manage-user-assign-role" */ '@/views/settings/manage-user/assign-role/Index');
const SettingsManageUserActivityLog = () =>
  import(/* webpackChunkName: "settings-manage-user-activity-log" */ '@/views/settings/manage-user/activity-log/Index');
const SettingsReminder = () => import(/* webpackChunkName: "settings-reminder" */ '@/views/settings/reminders/Root');
const SettingsReminderForm = () => import(/* webpackChunkName: "settings-reminder-form" */ '@/views/settings/reminders/Form');
const Settings9box = () => import(/* webpackChunkName: "settings-reminder" */ '@/views/settings/9box/Root');
const Settings9boxForm = () => import(/* webpackChunkName: "settings-reminder-form" */ '@/views/settings/9box/Form');

export default [
  {
    path: '/settings',
    component: Settings,
    children: [
      {
        path: '',
        name: 'settings',
        meta,
        component: SettingsGuard,
      },
      {
        path: 'template',
        meta,
        component: SettingsTemplate,
        children: [
          {
            path: '',
            name: 'settings_template',
            component: SettingsTemplateIndex,
          },
        ],
      },
      {
        path: 'payroll-group',
        meta: metaAdmin,
        component: SettingsPayroll,
        children: [
          {
            path: '',
            name: 'settings_payroll_group',
            component: SettingsPayrollIndex,
          },
          {
            path: 'form',
            name: 'settings_payroll_group_create',
            component: SettingsPayrollForm,
          },
          {
            path: 'form/:uuid/edit',
            name: 'settings_payroll_group_edit',
            component: SettingsPayrollForm,
          },
        ],
      },
      {
        path: 'manage-user',
        component: SettingsManageUser,
        children: [
          {
            path: '',
            name: 'manage_user',
            redirect: 'roles',
          },
          {
            path: 'roles',
            meta,
            component: SettingsManageUserRoles,
            children: [
              {
                path: 'add',
                name: 'settings_roles_add',
                meta,
                component: SettingsManageUserRolesForm,
              },
              {
                path: 'edit/:id',
                name: 'settings_roles_edit',
                meta,
                component: SettingsManageUserRolesForm,
              },
              {
                path: '',
                name: 'settings_roles',
                component: SettingsManageUserRolesIndex,
              },
            ],
          },
          {
            path: 'assign-role',
            name: 'settings_assign_role',
            meta,
            component: SettingsManageUserAssignRole,
          },
          {
            path: 'activity-log',
            name: 'settings_activity_log',
            meta: metaAdmin,
            component: SettingsManageUserActivityLog,
          },
        ],
      },
      {
        path: 'reminder',
        component: SettingsReminder,
        children: [
          {
            path: '',
            name: 'settings_reminder',
            meta,
            component: SettingsReminderForm,
          },
        ],
      },
      {
        path: '9box',
        component: Settings9box,
        children: [
          {
            path: '',
            name: 'settings_9box',
            meta,
            component: Settings9boxForm,
          },
        ],
      },
    ],
  },
];
